import React from "react"
import { AppRouteProps } from "@harea/component"

const FeaturesListContainer = React.lazy(() => import("./container/FeaturesListContainer"))

export const FeaturesRoutes: Array<AppRouteProps> = [
    {
        path: "features",
        element: <FeaturesListContainer />,
        roles: ["BACKOFFICE"],
        title: "std_feature",
    },
]
